import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import theme from '../theme';

const Canvas = styled.canvas`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  opacity: 0.15;
  pointer-events: none;
`;

const MatrixBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Matrix rain effect
    const fontSize = 14;
    const columns = canvas.width / fontSize;
    const drops = [];
    
    // Initialize drops
    for (let x = 0; x < columns; x++) {
      drops[x] = Math.random() * -100;
    }

    const draw = () => {
      // Semi-transparent black background for trail effect
      ctx.fillStyle = 'rgba(0, 0, 0, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Green text
      ctx.fillStyle = theme.colors.primary;
      ctx.font = `${fontSize}px ${theme.fonts.mono}`;

      // Draw characters
      for (let i = 0; i < drops.length; i++) {
        const text = theme.matrixChars[Math.floor(Math.random() * theme.matrixChars.length)];
        const x = i * fontSize;
        const y = drops[i] * fontSize;

        // Fade effect (brighter at top)
        const opacity = Math.max(0, 1 - (drops[i] * 0.01));
        ctx.fillStyle = `rgba(0, 255, 65, ${opacity})`;
        
        ctx.fillText(text, x, y);

        // Reset drop to top randomly
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        drops[i]++;
      }
    };

    const interval = setInterval(draw, 50);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return <Canvas ref={canvasRef} />;
};

export default MatrixBackground;

